import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';

// Suppress benign ResizeObserver loop errors (triggered by Matterport SDK)
const resizeObserverErr = /ResizeObserver loop/;
window.addEventListener('error', (e) => {
  if (resizeObserverErr.test(e.message)) e.stopImmediatePropagation();
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
